import { FC } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { subscription } from 'src/Router/routes'
import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { setSubscriptionFromLocation } from 'src/Redux/subscription-process/subscriptionFromLocation'
import { getCountryName } from 'src/Redux/auth-process/userSlice/selectors'
import { checkIsVATCountry } from 'src/Hooks/usePayment'
import { VAT_PERCENT } from 'src/Constants/constants'
import { useGetSubscriptionQuery } from 'src/Redux/subscription-process/subscriptionApi'
import { BalanceSubscriptionStatus } from 'src/Components/BalanceSubscriptionStatus'
import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'

const StyledSkeleton = styled(PrimarySkeleton)`
  border-radius: 16px;
  height: 65px;
`
export const BalanceSubscriptionInfo: FC = () => {
  const { data: plan, isLoading } = useGetSubscriptionQuery()
  const hasActiveOrCanceledSubscription = Boolean(
    plan?.status === 'active' || plan?.status === 'canceled',
  )
  const country = useAppSelector(getCountryName)
  const isVATCountry = checkIsVATCountry(country)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()

  if (isLoading) {
    return <StyledSkeleton role='skeleton' />
  }

  if (!plan || !hasActiveOrCanceledSubscription) {
    return null
  }

  const price = plan.package?.paymentAmount || 0

  const priceWithVAT = price + price * VAT_PERCENT

  const handleClick = (): void => {
    dispatch(setSubscriptionFromLocation(location.pathname))
    navigate(subscription)
  }
  const planName = plan.package?.name || ''
  const text = `${capitalizeFirstLetter(planName)} Plan`

  return (
    <BalanceSubscriptionStatus
      price={isVATCountry ? priceWithVAT : price}
      isActive={plan.status === 'active'}
      date={plan.nextPaymentDate}
      onManageClick={handleClick}
      planName={text}
    />
  )
}
